import React, { createContext, useContext, useMemo } from "react";

import { ScoreType } from "@/types";

export type InsightFilters = {
  scoreType: ScoreType;
  levels: number[];
  searchText: string;
  sortType?: string;
};

interface InsightFiltersValue {
  filters: InsightFilters;
  setFilters: React.Dispatch<React.SetStateAction<InsightFilters>>;
}

const InsightFiltersContext = createContext<InsightFiltersValue | undefined>(undefined);

/** Shares the insight layout's filter state with the insight views */
export const InsightFiltersProvider: React.FC<InsightFiltersValue & { children: React.ReactNode }> = ({
  filters,
  setFilters,
  children,
}) => {
  const value = useMemo(() => ({ filters, setFilters }), [filters, setFilters]);

  return (
    <InsightFiltersContext.Provider value={value}>
      {children}
    </InsightFiltersContext.Provider>
  );
};

export const useInsightFilters = () => {
  const context = useContext(InsightFiltersContext);
  if (!context) {
    throw new Error("useInsightFilters must be used within an InsightFiltersProvider");
  }
  return context;
};
